import { render, staticRenderFns } from "./ModuleTable.vue?vue&type=template&id=1ff48e0c"
import script from "./ModuleTable.vue?vue&type=script&lang=js"
export * from "./ModuleTable.vue?vue&type=script&lang=js"
import style0 from "./ModuleTable.vue?vue&type=style&index=0&id=1ff48e0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports